// src/pages/orders/components/DeliveryFollowUpStatusModal.jsx
import React, { useState } from 'react';
import { X, Truck, Loader2 } from 'lucide-react';
import styles from './DeliveryFollowUpStatusModal.module.css';

const DeliveryFollowUpStatusModal = ({ courierStatuses, selectedIds, onClose, onSave, isSaving }) => {
  const [localSelected, setLocalSelected] = useState(selectedIds || []);

  const toggleStatus = (statusId) => {
    setLocalSelected(prev =>
      prev.includes(statusId) ? prev.filter(id => id !== statusId) : [...prev, statusId]
    );
  };

  const handleSelectAll = () => setLocalSelected(courierStatuses.map(cs => cs.id));
  const handleClearAll = () => setLocalSelected([]);

  const handleSave = () => onSave(localSelected);

  // Group by courier company for readability
  const groupedStatuses = courierStatuses.reduce((groups, cs) => {
    const companyName = cs.courierCompany?.name || 'Other';
    if (!groups[companyName]) groups[companyName] = [];
    groups[companyName].push(cs);
    return groups;
  }, {});

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div>
            <h3>Delivery Follow-up Statuses</h3>
            <p>Select the courier statuses to include in this list</p>
          </div>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.quickActions}>
            <button type="button" onClick={handleSelectAll} className={styles.quickButton}>Select all</button>
            <button type="button" onClick={handleClearAll} className={styles.quickButton}>Clear all</button>
          </div>

          {courierStatuses.length === 0 ? (
            <div className={styles.emptyState}>No courier statuses found.</div>
          ) : (
            <div className={styles.groupsContainer}>
              {Object.entries(groupedStatuses).map(([companyName, statuses]) => (
                <div key={companyName} className={styles.group}>
                  <h4><Truck size={14} />{companyName}</h4>
                  <div className={styles.statusList}>
                    {statuses.map(cs => (
                      <label key={cs.id} className={styles.statusOption}>
                        <input
                          type="checkbox"
                          checked={localSelected.includes(cs.id)}
                          onChange={() => toggleStatus(cs.id)}
                        />
                        <span>{cs.statusLabel || cs.statusCode}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={styles.modalFooter}>
          <button onClick={onClose} className={styles.cancelButton} disabled={isSaving}>Cancel</button>
          <button onClick={handleSave} className={styles.saveButton} disabled={isSaving}>
            {isSaving ? <Loader2 size={16} className={styles.spinnerIcon} /> : null}
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryFollowUpStatusModal;
